module.exports = __webpack_public_path__ + "static/network-error.4a0ff503.png";